import styled from 'styled-components';


export const DeleteButton = styled.button`
  background: none;
  border: none;
  color: #f00;
  cursor: pointer;
  text-transform: uppercase;

  &:focus,
  &:active {
    outline: none;

  }

  &:hover {
    color: darken(#f00, 10%);
  }
`;

export const MakeDefaultButton = styled.button`
  background: none;
  border: none;
  color: ${props => props.theme.colors.primary};
  cursor: pointer;
  text-transform: capitalize;

  &:focus,
  &:active {
    outline: none;

  }

  &:hover {
    color: darken(${props => props.theme.colors.primary}, 10%);
  }
`;
